<template>
  <div v-if="item.type == 'title'">
    <div class="text-4xl font-medium text-gray-600">
      {{ item.meta.title_text }}
    </div>
    <div class="text-common-grey mt-2">
      {{ item.meta.sub_title_text }}
    </div>
  </div>
  <div v-if="item.type == 'commands_list'" class="flex flex-wrap justify-between w-full">
    <div
      v-for="(command, command_i) in item.meta?.commands"
      :key="command_i"
      class="mt-4"
      :style="{ width: `${(1 / (item.meta?.commands.length > 3 ? 3 : item.meta?.commands.length)) * 100}%` }">
      <div class="text-2xl font-medium text-[#841FF4] mb-4">
        {{ command.title }}
      </div>
      <div class="flex flex-col flex-wrap h-fit">
        <div v-for="(command_item, c_i) in command.items" :key="c_i">
          <transition
            enter-active-class="transition duration-300 ease-out"
            enter-from-class="transform opacity-0 -translate-x-10"
            enter-to-class="transform opacity-100 translate-x-0"
            leave-active-class="transition duration-0 ease-in"
            leave-from-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0">
            <div
              v-if="!command_item.label.includes('__')"
              :key="command_item.label"
              class="text-common-grey w-full flex items-center py-1 truncate whitespace-nowrap text-sm hover:text-black hover:translate-x-1 duration-300 !transition-all ease-in-out cursor-pointer">
              <ArrowRight class="min-w-4 min-h-4 w-4 h-4 mr-2" />
              <div
                class="w-[80%] truncate"
                @click="
                  () => {
                    command_item.action ? command_item.action() : null
                  }
                ">
                {{ command_item.label }}
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>

  <div v-if="item.type == 'form'" class="ml-10 mr-10">
    <div v-for="(field, field_index) in item.meta.fields" :key="field.label">
      <div
        v-if="
          field.type == 'text' &&
            (!field_index
              ? true
              : field.show_if_last_field_has_value
                ? item.meta.fields[field_index - 1].value == field.show_if_last_field_has_value
                : true)
        "
        :class="[
          { 'flex items-center': field.inline },
          {
            'border-b pb-2':
              item.meta.fields[field_index - 1]?.divider ||
              (field.divider && !(item.meta.fields[field_index + 1]?.show_if_last_field_has_value == field.value))
          }
        ]"
        class="mt-4 mb-4">
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_label" class="font-medium relative z-10">
            {{ field.label }}
          </div>
        </transition>
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_value" class="border border-dashed h-8 border-transparent hover:border-gray-300 transition-all ease-in-out">
            <TextInput
              v-model="field.value"
              :value="field.value"
              :validate-on-input="true"
              :no-border="true"
              label=""
              :classes="'w-full'"
              input-classes="appearance-none block w-full  px-3 py-0 !-ml-2 mt-1 y-1 py-0 border border-gray-300 rounded-md  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
              name="name"
              type="text"
              :placeholder="$t('Start typing')" />
          </div>
        </transition>
      </div>

      <div
        v-if="
          field.type == 'selection' &&
            (!field_index
              ? true
              : field.show_if_last_field_has_value
                ? item.meta.fields[field_index - 1].value == field.show_if_last_field_has_value
                : true)
        "
        clas
        :class="[
          { 'flex items-center': field.inline },
          {
            'border-b pb-2':
              field.show_value &&
              (item.meta.fields[field_index - 1]?.divider ||
                (field.divider && !(item.meta.fields[field_index + 1]?.show_if_last_field_has_value == field.value)))
          }
        ]"
        class="mt-4 mb-4">
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_label" class="font-medium relative z-10">
            {{ field.label }}
          </div>
        </transition>
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_value" class="w-64 mt-2 relative">
            <SelectInput
              :relative-pos="true"
              name="selection"
              :input-classes="'text-left'"
              :is-box-background="true"
              :show-label="false"
              :allow-null="!field.required"
              :items="field.options"
              :label="$t('Select')"
              :value="field.value"
              @update:currentItem="
                ($event) => {
                  field.value = $event
                }
              " />
          </div>
        </transition>
      </div>

      <div
        v-if="
          field.type == 'multi_select' &&
            (!field_index
              ? true
              : field.show_if_last_field_has_value
                ? item.meta.fields[field_index - 1].value == field.show_if_last_field_has_value
                : true)
        "
        :class="[
          { 'flex items-center': field.inline },
          {
            'border-b pb-2':
              field.show_value &&
              (item.meta.fields[field_index - 1]?.divider ||
                (field.divider && !(item.meta.fields[field_index + 1]?.show_if_last_field_has_value == field.value)))
          }
        ]"
        class="mt-4 mb-4">
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_label" class="font-medium relative z-10">
            {{ field.label }}
          </div>
        </transition>
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_value" class="w-64 mt-2 relative">
            <MultiSelectInput
              v-model:current-items="field.value"
              :relative-pos="true"
              name="multi_select"
              :items="field.options"
              :allow-null="!field.required"
              :label="$t('Select')"
              classes="w-full"
              input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
              :selection-text="null"
              :placeholder="$t('Select')"
              :show-label="false" />
          </div>
        </transition>
      </div>

      <div
        v-if="
          field.type == 'multi_switch_select' &&
            (!field_index
              ? true
              : field.show_if_last_field_has_value
                ? item.meta.fields[field_index - 1].value == field.show_if_last_field_has_value
                : true)
        "
        :class="[
          { 'flex items-center': field.inline },
          { 'border-b pb-2': field.show_value && (item.meta.fields[field_index - 1]?.divider || field.divider) }
        ]"
        class="mt-4 mb-4">
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_label" class="font-medium relative z-10">
            {{ field.label }}
          </div>
        </transition>
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <div v-if="field.show_value" class="mt-2 relative" :class="[{ 'flex items-center justify-between': field.switches_inline }]">
            <div v-for="switch_item in field.switches" :key="switch_item.label">
              <div class="flex space-x-1 items-center">
                <div class="text-sm text-common-grey">
                  {{ switch_item.label }}
                </div>
                <div>
                  <Switch
                    v-model="switch_item.value"
                    :class="[
                      switch_item.value ? 'bg-blue' : 'bg-gray-200',
                      'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
                    ]">
                    <span
                      aria-hidden="true"
                      :class="[
                        switch_item.value && $store.state.portfolio.ui_options?.language == 'ar'
                          ? '-translate-x-5'
                          : switch_item.value
                            ? 'translate-x-5'
                            : 'translate-x-0',
                        'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                      ]" />
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-0 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <div
        v-if="item.meta.show_confirm_button"
        class="mt-4 -ml-3"
        :class="[{ 'pointer-events-none opacity-60': !formValidCalc(item.meta.fields) }]"
        @click="item.meta.confirm_button_action">
        <button class="btn cancel-btn flex space-x-2 items-center">
          <CircleCheck class="text-green-500 cursor-pointer w-6 h-6" />
          <div>{{ $t("Confirm") }}</div>
        </button>
      </div>
    </transition>
    <div class="mt-4">
      {{ item.meta.follow_up_text }}
    </div>
  </div>

  <div v-if="item.type == 'dialogue'" class="mt-5 mb-2">
    <div class="flex items-center space-x-2">
      <!-- <img
        v-if="$store.state.auth.user.avatar && item.meta.sender=='user'"
        onerror="this.onerror=null; this.src=window.default_avatar"
        class="inline-block w-7 h-7 rounded-full"
        :src="$store.state.auth.user.avatar"
        alt=""> -->

      <Avatar
        v-if="item.meta.sender == 'user'"
        :radius="30"
        :first-name="$store.state.auth.user.first_name"
        :last-name="$store.state.auth.user.last_name" />

      <div v-if="item.meta.sender == 'ai'" class="p-1 to-[#2DA7D7] text-white bg-gradient-to-r rounded-full from-[#841FF4]">
        <AIMenuIcon :class="[{ 'animate-spin': !item.meta.text }]" class="w-5 h-5" />
      </div>
      <div />
      <div class="w-5/6">
        <div class="flex items-center" :class="[{ 'text-common-grey/80 ': item.meta.action_performed }]">
          <span v-if="item.meta.action_performed">
            <transition
              enter-active-class="transition duration-300 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-0 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0">
              <Check v-if="item.meta.text" class="w-6 h-6 mr-2 font-bold text-green-600" />
            </transition> </span>{{ item.meta.text }}
        </div>
      </div>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform translate-y-[40px]  opacity-0"
      enter-to-class="transform translate-y-0  opacity-100"
      leave-active-class="transition duration-0 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <div v-if="item.meta.attached_item?.show" class="mt-2 w-[89%] ml-[6%] h-fit">
        <AttachedGoalCard v-if="item.meta.attached_item.type == 'goal'" :goal="item.meta.attached_item.data" />
        <AttachedTaskCard v-if="item.meta.attached_item.type == 'task'" :task="item.meta.attached_item.data" />
        <AttachedPlanCard v-if="item.meta.attached_item.type == 'plan'" :plan="item.meta.attached_item.data" />
        <AttachedInteractionCard v-if="item.meta.attached_item.type == 'interaction'" :interaction="item.meta.attached_item.data" />
      </div>
    </transition>

    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-0 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <div class="ml-[6%] mt-2">
        {{ item.meta.follow_up_text }}
      </div>
    </transition>
  </div>
  <div v-if="item.type == 'selection_boxes'" class="ml-10 h-full border rounded-lg p-1 pl-2">
    <div class="grid grid-cols-2">
      <div
        v-for="(box, box_index) in item.meta.selection_list"
        :key="box.title"
        class="w-full group cursor-pointer"
        :class="[{ 'pointer-events-none': item.meta.selection_list.filter((l) => l.selected).length }]"
        @click="
          () => {
            if (!box.selected) box.action(box.title)
            box.selected = true
          }
        ">
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform -translate-y-10 opacity-0"
          enter-to-class="transform translate-y-0 opacity-100"
          leave-active-class="transition duration-0 ease-in"
          leave-from-class="transform translate-y-0 opacity-100"
          leave-to-class="transform -translate-y-10 opacity-0">
          <div v-if="box.show_box" class="h-32 relative">
            <div
              :class="[
                { '!h-[105%]': box_index > item.meta.selection_list.length - 3 },
                { 'bg-gradient bg-gradient-to-t from-[#B0B0B0] group-hover:via-[#841FF4] group-hover:to-[#B0B0B010]': box_index < 2 },
                { 'bg-gradient bg-gradient-to-t from-[#B0B0B0] via-[#841FF4] to-[#B0B0B010]': box_index < 2 && box.selected },
                {
                  'bg-gradient bg-gradient-to-b from-[#B0B0B0] group-hover:via-[#841FF4] group-hover:to-[#841FF410]':
                    box_index > item.meta.selection_list.length - 3
                },
                {
                  'bg-gradient bg-gradient-to-b from-[#B0B0B0] via-[#841FF4] to-[#841FF410]':
                    box_index > item.meta.selection_list.length - 3 && box.selected
                },
                {
                  'bg-gradient-to-b from-[#B0B0B0] to-[#B0B0B0] group-hover:via-[#841FF4] group-hover:to-[#B0B0B0]':
                    box_index > 1 && box_index < item.meta.selection_list.length - 2
                },
                {
                  'bg-gradient-to-b from-[#B0B0B0]  via-[#841FF4] to-[#B0B0B0]':
                    box_index > 1 && box_index < item.meta.selection_list.length - 2 && box.selected
                }
              ]"
              class="w-[2px] rouned-lg absolute left-[52px] -top-[17.5%] h-[125%] z-1 !transition-all !ease-in-out !duration-300" />
            <div
              :class="[{ '!bg-[#841FF420]': box.selected }]"
              class="bg-gray-100 group-hover:bg-[#841FF420] !transition-all !ease-in-out !duration-300 rounded-lg h-[97%] p-2 mt-[5%] w-[97%]">
              <div class="flex items-center">
                <div
                  :class="[{ '!from-[#841FF4]': box.selected }]"
                  class="w-6 bg-gradient bg-gradient-to-l from-[#B0B0B0] group-hover:from-[#841FF4] !transition-all !ease-in-out !duration-300 h-[2px]" />
                <div
                  :class="[{ '!shadow-md': box.selected }]"
                  class="w-10 h-10 border rounded-full flex items-center justify-center bg-white relative z-10 group-hover:shadow-md shadow-purple-400 !transition-all !ease-in-out !duration-300">
                  <component :is="box.icon" :color="box.selected ? '#841FF4' : 'black'" class="w-6 h-6 group-hover:h-0 group-hover:w-0" />
                  <component :is="box.icon" color="#841FF4" class="w-0 h-0 group-hover:h-6 group-hover:w-6" />
                </div>
                <div class="ml-4 -mt-3 relative">
                  <div
                    :class="[{ '!text-[#841FF4]': box.selected }]"
                    class="text-lg font-medium group-hover:text-[#841FF4] !transition-all !ease-in-out !duration-300">
                    {{ box.title }}
                  </div>
                  <div class="absolute mt-0 h-14 text-sm w-44">
                    {{ box.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>

  <div v-if="item.type == 'fancy_selection_list'" class="ml-10 h-full">
    <div v-for="selection_item in item.meta.selection_list" :key="selection_item.title">
      <transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="transform -translate-y-10 opacity-0"
        enter-to-class="transform translate-y-0 opacity-100"
        leave-active-class="transition duration-0 ease-in"
        leave-from-class="transform translate-y-0 opacity-100"
        leave-to-class="transform -translate-y-10 opacity-0">
        <div v-if="selection_item.show_selection_item" class="flex w-full items-center border-b pb-6 pt-2">
          <div class="w-10 h-10">
            <component :is="selection_item.icon" class="w-9 h-9" />
          </div>
          <div class="w-4/6 ml-4">
            <div class="text-lg font-medium">
              {{ selection_item.title }}
            </div>
            <div class="text-sm text-common-grey mt-2">
              {{ selection_item.sub_title }}
            </div>
          </div>

          <div class="ml-auto mr-10">
            <Switch
              v-model="selection_item.selected"
              :class="[
                selection_item.selected ? 'bg-blue' : 'bg-gray-200',
                'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
              ]">
              <span
                aria-hidden="true"
                :class="[
                  selection_item.selected && $store.state.portfolio.ui_options?.language == 'ar'
                    ? '-translate-x-5'
                    : selection_item.selected
                      ? 'translate-x-5'
                      : 'translate-x-0',
                  'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                ]" />
            </Switch>
          </div>
        </div>
      </transition>
    </div>

    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-0 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <div
        v-if="item.meta.show_confirm_button"
        class="mt-2"
        :class="[{ 'pointer-events-none opacity-60': !item.meta.selection_list.filter((s) => s.selected).length }]"
        @click="item.meta.confirm_button_action">
        <button class="btn cancel-btn flex space-x-2 items-center">
          <CircleCheck class="text-green-500 cursor-pointer w-6 h-6" />
          <div>{{ $t("Confirm") }}</div>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import MultiSelectInput from "@/components/shared/MultiSelectInput"

import { Switch } from "@headlessui/vue"
import SelectInput from "@/components/shared/SelectInput.vue"

import Avatar from "@/components/shared/Avatar.vue"
import { Check, CircleCheck, ArrowRight } from "lucide-vue-next"
import AIMenuIcon from "@/components/shared/icons/AIMenuIcon"

import AttachedGoalCard from "./AttachedGoalCard.vue"
import AttachedTaskCard from "./AttachedTaskCard.vue"
import AttachedPlanCard from "./AttachedPlanCard.vue"
import AttachedInteractionCard from "./AttachedInteractionCard.vue"
import TextInput from "@/components/shared/TextInput.vue"

export default {
  components: {
    SelectInput,
    Switch,
    TextInput,
    AIMenuIcon,
    ArrowRight,
    Avatar,
    Check,
    AttachedGoalCard,
    AttachedPlanCard,
    AttachedInteractionCard,
    AttachedTaskCard,
    MultiSelectInput,
    CircleCheck
  },
  props: { item: null },
  emits: [],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {
    formValidCalc(fields) {
      let valid = true
      fields.forEach((field, i) => {
        if (field.required) {
          if (
            field.type == "multi_switch_select" &&
            (i && field.show_if_last_field_has_value ? fields[i - 1].value == field.show_if_last_field_has_value : true)
          ) {
            if (!field.switches.filter((s) => s.value).length) {
              valid = false
            }
          } else if (
            field.type == "multi_select" &&
            (i && field.show_if_last_field_has_value ? fields[i - 1].value == field.show_if_last_field_has_value : true)
          ) {
            if (!field.value?.length) {
              valid = false
            }
          } else if (i && field.show_if_last_field_has_value ? fields[i - 1].value == field.show_if_last_field_has_value : true) {
            if (!field.value) {
              valid = false
            }
          }
        }
      })
      return valid
    }
  }
}
</script>
